<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="title-text">Suggest site</h1>
      <h2 class="subtitle-text">
        Can't find your favorite site? Let us know
      </h2>
    </div>

    <div class="features-container">
      <div class="form-container">
        <div style="margin-bottom: 1.5rem;">
          <p class="form-title-text">SITE NAME*</p>
          <input
            class="input-container input-container-medium"
            style="width: 100%;"
            placeholder="Example: LinkedIn"
            ref="siteName"
            v-model="siteName"
            @click="select($refs.siteName, siteName)"
            type="text"
            @keyup.enter="select($refs.siteUrl, siteUrl)"
            maxlength="1000"
          />

          <p v-if="errors.siteName" class="p-error">
            ⚠️ This field is required
          </p>
        </div>
      </div>
      <div class="form-container">
        <div style="margin-bottom: 1.5rem;">
          <p class="form-title-text">SITE URL*</p>
          <input
            class="input-container input-container-medium"
            style="width: 100%;"
            placeholder="https://websitename.com"
            ref="siteUrl"
            v-model="siteUrl"
            @click="select($refs.siteUrl, siteUrl)"
            type="text"
            @keyup.enter="select($refs.description, description)"
            maxlength="1000"
          />

          <p v-if="errors.siteUrlBadFormat" class="p-error">
            ⚠️ It doesn't look like a website format (https://name.com)
          </p>
          <p v-if="errors.siteUrl" class="p-error">⚠️ This field is required</p>
        </div>
      </div>
      <div class="form-container">
        <div style="margin-bottom: 1.5rem;">
          <p class="form-title-text">INDUSTRY FOCUS OR NICHE OF THE SITE*</p>
          <input
            class="input-container input-container-medium"
            style="width: 100%;"
            placeholder="Example: IT"
            ref="niche"
            v-model="niche"
            @click="select($refs.niche, niche)"
            type="text"
            @keyup.enter="select($refs.people, people)"
            maxlength="1000"
          />

          <p v-if="errors.niche" class="p-error">⚠️ This field is required</p>
        </div>
      </div>
      <div class="form-container">
        <div style="margin-bottom: 1.5rem;">
          <p class="form-title-text">
            WHAT KIND OF PEOPLE THIS SITE FOCUS ON?*
          </p>
          <input
            class="input-container input-container-medium"
            style="width: 100%;"
            placeholder="Example: Developers, Designers..."
            ref="people"
            v-model="people"
            @click="select($refs.people, people)"
            @keyup.enter="select($refs.where, where)"
            type="text"
            maxlength="1000"
          />

          <p v-if="errors.people" class="p-error">⚠️ This field is required</p>
        </div>
      </div>
      <div class="form-container">
        <div style="margin-bottom: 0.5rem;">
          <p class="form-title-text">KEYWORDS TO PROPER CLASSIFY THIS SITE*</p>

          <Tags ref="tags" @added-tags="tags.push($event)" />

          <div class="tags-container">
            <Tag :tag="tag" v-for="tag in tags" :key="tag" @removed-tag="removeTag($event)" />
          </div>

          <p v-if="errors.tags" class="p-error">⚠️ At least one tag needed</p>
        </div>
      </div>
      <div class="form-container">
        <div style="margin-bottom: 0.5rem;">
          <p class="form-title-text">WHAT REGION IS THIS SITE FOCUSED ON?</p>
          <input
            class="input-container input-container-medium"
            style="width: 100%;"
            placeholder="Examples: USA, Worldwide"
            ref="where"
            v-model="where"
            @click="select($refs.where, where)"
            type="text"
            maxlength="1000"
          />
        </div>
      </div>

      <div class="form-container">
        <p class="form-title-text">SITE DESCRIPTION</p>
        <textarea
          class="input-container text-area-container-medium"
          cols="50"
          rows="5"
          style="width: 100%;"
          placeholder="What is this site about?"
          ref="description"
          v-model="description"
          @click="select($refs.description, description)"
          type="text"
          @keyup.enter="select($refs.why, why)"
          maxlength="1000"
        ></textarea>
        <p class="form-info-text">Optional.</p>

        <p v-if="errors.description" class="p-error">
          ⚠️ This field is required
        </p>
      </div>
      <div class="form-container">
        <p class="form-title-text">WHY THIS SITE MUST BE ON JOBBOARDY?</p>
        <textarea
          class="input-container text-area-container-medium"
          cols="50"
          rows="5"
          style="width: 100%;"
          placeholder="Explain the reasons why we have to add it on JobBoardy"
          ref="why"
          v-model="why"
          @click="select($refs.why, why)"
          type="text"
          @keyup.enter="select($refs.niche, niche)"
          maxlength="1000"
        ></textarea>
        <p class="form-info-text">Optional.</p>

        <p v-if="errors.why" class="p-error">⚠️ This field is required</p>
      </div>
    </div>

    <div class="center-items">
      <button @click="send()" class="primary-button" style="padding: 1rem 3rem;" type="button">
        Send your suggestion 🚀
      </button>
    </div>
    <div class="center-items">
      <p v-if="errors.missingFields" class="p-error">
        ⚠️ Missing required fields
      </p>
      <p v-if="errors.serverError" class="p-error">
        ⚠️ Unknown error, contact the devs
      </p>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
import utils from "@/utils";

import Tag from "@/components/Tag";
import Tags from "@/components/Tags";

export default {
  components: {
    Tag,
    Tags,
  },

  created() {
    window.scrollTo(0, 0);
  },

  data() {
    return {
      tags: [],
      why: "",
      description: "",
      siteName: "",
      siteUrl: "",
      niche: "",
      people: "",
      where: "",
      errors: {
        tags: false,
        why: false,
        description: false,
        siteName: false,
        siteUrl: false,
        niche: false,
        people: false,
        serverError: false,
        missingFields: false,
      },
    };
  },

  methods: {
    removeTag(tag) {
      this.$refs.tags.removeTag(tag);
      const i = this.tags.indexOf(tag);
      const exist = i > -1;
      if (exist) {
        this.tags.splice(i, 1);
      }
    },

    validate() {
      this.errors.tags = false;
      this.errors.why = false;
      this.errors.description = false;
      this.errors.siteName = false;
      this.errors.siteUrlBadFormat = false;
      this.errors.siteUrl = false;
      this.errors.niche = false;
      this.errors.people = false;
      this.errors.serverError = false;
      this.errors.missingFields = false;

      let isValid = true;

      if (this.why == null || this.why === "") {
        this.errors.why = true;
        isValid = false;
      }

      if (this.people == null || this.people === "") {
        this.errors.people = true;
        isValid = false;
      }

      if (this.niche == null || this.niche === "") {
        this.errors.niche = true;
        isValid = false;
      }

      if (this.siteUrl == null || this.siteUrl === "") {
        this.errors.siteUrl = true;
        isValid = false;
      } else {
        if (!utils.validURL(this.siteUrl)) {
          this.errors.siteUrlBadFormat = true;
          isValid = false;
        }
      }

      if (this.siteName == null || this.siteName === "") {
        this.errors.siteName = true;
        isValid = false;
      }

      if (this.description == null || this.description === "") {
        this.errors.description = true;
        isValid = false;
      }

      if (!Array.isArray(this.tags) || this.tags.length === 0) {
        this.errors.tags = true;
        isValid = false;
      }

      if (!isValid) {
        this.errors.missingFields = true;
      }

      return isValid;
    },

    async send() {
      if (!this.validate()) {
        return;
      }

      try {
        this.$store.state.loading.show = true;

        const set = {
          tags: this.tags,
          why: this.why,
          description: this.description,
          siteName: this.siteName,
          siteUrl: this.siteUrl,
          niche: this.niche,
          people: this.people,
          where: this.where,
        };
        await firebase.functions.httpsCallable("suggestSite")(set);

        this.$store.state.loading.show = false;
        this.$router.push({ path: "/suggest-site-thank-you" });
      } catch (e) {
        console.error(e);
        this.errors.serverError = true;
      }
    },

    select(ref, model) {
      ref.focus();
      ref.setSelectionRange(0, model.length);
    },
  },
};
</script>

<style></style>
